import * as atypes from './action-types'

export default {
  [atypes.TWEETLISTPAGE_SET_SCPOS] (ctx, {top}) {
    ctx.commit('TweetListPage_setScPos', {top})
  },
  [atypes.TWEETLISTPAGE_CHANGE_TYPE] (ctx, {type}) {
    ctx.commit('TweetListPage_changeType', {type})
  },
  [atypes.STOCKLISTPAGE_SET_SCPOS] (ctx, {top}) {
    ctx.commit('StockListPage_setScPos', {top})
  },
  [atypes.FLASH_CLEAR_MSG] (ctx) {
    ctx.commit('Flash_changeMsg', {msg: null})
  },
  [atypes.FLASH_SET_MSG] (ctx, {msg}) {
    ctx.commit('Flash_changeMsg', {msg})
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js